// extracted by mini-css-extract-plugin
export default {"pAlert":"FormShipment_pAlert__4ACrP","pAlertt":"FormShipment_pAlertt__7fUfy","status":"FormShipment_status__BoYex","minWidth80":"FormShipment_minWidth80__-aNTy"};